import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FooterState } from "./footer.state";
import { getFooter } from "./footer.thunk";
import { FooterResponse } from "./footer.types";

const initialState: FooterState = {
  data: null,
  status: "idle",
  error: null,
};

export const footerSlice = createSlice({
  name: "footer",
  initialState,
  reducers: {
    resetFooter: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
    },
    setFooter: (state, action: PayloadAction<FooterResponse["data"]>) => {
      state.data = action.payload;
      state.status = "success";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFooter.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        getFooter.fulfilled,
        (state, action: PayloadAction<FooterResponse>) => {
          state.status = "success";
          state.data = action.payload.data;
        },
      )
      .addCase(
        getFooter.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error =
            action.payload ?? "Footer verileri yüklenirken bir hata oluştu.";
        },
      );
  },
});

export const { resetFooter, setFooter } = footerSlice.actions;

export default footerSlice.reducer;